import { render } from "./DSPInformationModal.vue?vue&type=template&id=439bc0de&scoped=true&ts=true"
import script from "./DSPInformationModal.vue?vue&type=script&lang=ts"
export * from "./DSPInformationModal.vue?vue&type=script&lang=ts"

import "./DSPInformationModal.vue?vue&type=style&index=0&id=439bc0de&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-439bc0de"]])

export default __exports__